import getApi from '../../api'
import { Indications } from '../../model/Drug'

export const getIndications = (search: string, signal?: AbortSignal) =>
  getApi().get<Array<Indications>>(`/drugs/indications`, { search }, { signal })
